export default {"src":"/_next/static/media/Seon_1.8a2bfd76.svg","height":80,"width":80};